import vhdl from "refractor/vhdl";
export default vhdl;